import api from '../api.js';
import * as types from '../types.js';

export default {

	html: `
		<style>
			#input-labels #company_id	{ width: 14rem;		}
			#input-labels #device_id	{ width: 30rem;		}
			#input-labels .product		{ width: 20rem;		}
			#input-labels .lot			{ width: 8rem;		}
			#input-labels .date			{ width: 7rem;		}
			#input-labels .labels		{ width: 4.5rem; text-align: right;	}
		</style>
		<form id="input-labels" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="products">
			</datalist>
			<datalist id="devices">
			</datalist>
			<div class="title">
				Etiquetas&nbsp;de&nbsp;Lotes
			</div>
			<div class="fsb mtm">
				<input id="company_id" type="hidden">
				<input id="input_id" type="hidden">
				<label title="Empresa para seleção da impressora">Empresa<sup>*</sup>
					<input id="device_company_id" type="text" list="companies" required>
				</label>
				<label title="Identificador da impressora">Impressora<sup>*</sup>
					<input id="device_id" type="text" list="devices" required>
				</label>
				<label title="SIAL na AWS: envie ZPL ao agente local que envia para a impressora na rede interna">Usar agente local
					<input id="use_local_agent" type="checkbox" title="SIAL na AWS: envie ZPL ao agente local">
				</label>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<!--
							<th></th>
							-->
							<th>Produto</th>
							<th>Lote</th>
							<th>Fabricação</th>
							<th>Validade</th>
							<th>Etiquetas<sup>*</sup></th>
						</tr>
					</thead>
					<tbody>
						<tr class="row" data-size="10">
							<input id="id-0" type="hidden">
							<!--
							<td>
								<input id="checkbox-0" type="checkbox">
							</td>
							-->
							<td title="Produto">
								<input id="product_id-0" class="product" type="text" list="products" disabled>
							</td>
							<td title="Numeração do lote">
								<input id="lot_number-0" class="lot" type="text" disabled>
							</td>
							<td title="Data de fabricação">
								<input id="manufacture_date-0" class="date" type="text" disabled>
							</td>
							<td title="Data de validade">
								<input id="expiration_date-0" class="date" type="text" disabled>
							</td>
							<td title="Etiquetas">
								<input id="labels-0" class="labels" type="number" min="0" max="99" required>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="fsb mtm">
				<span>
					<!--
					<img class="bn_Invert" src="img/check.svg" title="Inverter caixas de seleção">
					<img class="bn_Clear" src="img/clear.svg" title="Apagar conteúdo das linhas selecionadas">
					<img class="bn_Insert" src="img/add.svg" title="Anexar uma nova linha">
					<img class="bn_Remove" src="img/remove.svg" title="Remover linhas selecionadas">
					<img class="bn_MoveUp" src="img/up.svg" title="Mover linhas selecionadas para cima">
					<img class="bn_MoveDn" src="img/down.svg" title="Mover linhas selecionadas para baixo">
					-->
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
					<button class='bn_Enter button'>Imprimir</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#input-labels',
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub()] },
		{ properties: { selector: '#input_id' }, types: [] },
		{ properties: { selector: '#device_company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#use_local_agent' }, types: [types.checkbox()] },
		{ properties: { selector: '#device_id' }, types: [types.pubsub(), types.datalist(), types.observer('device_company_id'), types.obs_load_options('devices')] },		// TODO: Filtrar apenas dispositivos do tipo "P" (Printer)
		//{ properties: { selector: '#checkbox-0' }, types: [types.checkbox()] },
		{ properties: { selector: '#id-0' }, types: [] },
		{ properties: { selector: '#product_id-0' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('products', { labels: ['sku', 'name'] })] },
		{ properties: { selector: '#lot_number-0' }, types: [types.caps()] },
		{ properties: { selector: '#manufacture_date-0' }, types: [types.date()] },
		{ properties: { selector: '#expiration_date-0' }, types: [types.date()] },
		{ properties: { selector: '#labels-0' }, types: [types.number(0, 2)] },
	]

};

